/**
 * Utility to clear old Claude models from localStorage
 * Run this in browser console if needed: localStorage.removeItem('agentic-ivy-settings')
 */

import { DEFAULT_MODEL, AVAILABLE_MODELS } from '../types/models';

/**
 * Check if the current stored model is valid, and fix it if not
 */
export function validateAndFixStoredModel(): boolean {
  try {
    const storedSettings = localStorage.getItem('agentic-ivy-settings');

    if (!storedSettings) {
      console.log('✅ No stored settings found, will use default model');
      return true;
    }

    const settings = JSON.parse(storedSettings);
    const currentModel = settings?.state?.currentModel;

    if (!currentModel) {
      console.log('✅ No model in stored settings');
      return true;
    }

    // Check if model is valid
    const isValidModel = AVAILABLE_MODELS.some(m => m.id === currentModel);

    if (!isValidModel) {
      console.warn(`⚠️ Invalid model "${currentModel}" found in localStorage, fixing...`);

      // Update the stored settings
      settings.state.currentModel = DEFAULT_MODEL;
      localStorage.setItem('agentic-ivy-settings', JSON.stringify(settings));

      console.log(`✅ Updated model to ${DEFAULT_MODEL}`);

      // Suggest page reload
      console.log('🔄 Please reload the page to apply changes');
      return false;
    }

    console.log(`✅ Model "${currentModel}" is valid`);
    return true;

  } catch (error) {
    console.error('❌ Error validating stored model:', error);
    return false;
  }
}

/**
 * Force clear all settings (nuclear option)
 */
export function clearAllSettings(): void {
  localStorage.removeItem('agentic-ivy-settings');
  console.log('✅ Cleared all stored settings, page will reload with defaults');
  window.location.reload();
}

// Auto-run validation on import (runs once when the app loads)
if (typeof window !== 'undefined') {
  validateAndFixStoredModel();
}
